<script setup>
const props = defineProps({
  count: Number,
  maxLimit: {
    type: Number,
    default: 999
  }
});
</script>

<template>
  <div v-if="count" class="notifications__count">
    <span>{{ count > maxLimit ? '999+' : count }}</span>
  </div>
</template>

<style lang="scss" scoped>
.notifications__count {
  background-color: #BA1A1A;
  border-radius: 100px;
  padding: 0 4px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;

  span {
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    color: #fff !important;
  }
}
</style>
